export function ContractsPage() {
  return (
    <div>
      <h1>Contract Page</h1>
    </div>
  );
}
